
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/coaching",
      function () {
        return require("private-next-pages/coaching.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/coaching"])
      });
    }
  